import { captureException } from '@sentry/react';
import { enqueueSnackbar } from 'notistack';

export const handleError = (
    error: unknown,
    errorMessage?: string,
    key?: string
) => {
    captureException(error);
    if (errorMessage) {
        enqueueSnackbar(errorMessage, {
            variant: 'error',
            key,
        });
    }
};
